import { supabase } from '../lib/supabase'
import type { InboxQueue } from '../types/inbox'

export async function fetchInboxQueues(): Promise<InboxQueue[]> {
  const { data, error } = await supabase
    .from('inbox_queues')
    .select('id, name, slug, label_id, sort_order')
    .eq('is_active', true)
    .order('sort_order', { ascending: true })
  if (error) throw error
  return (data || []) as InboxQueue[]
}
